import { useEffect } from 'react';
import { useLazyDataModel } from '@thd-nucleus/data-sources';
import { heightRE, lengthRE, widthRE } from '../constants';

export const useOrderSample = ({ itemId, storeId, zipCode }) => {
  const [makeItemRequest, { loading, data: productData }] = useLazyDataModel('clientOnlyProduct', {
    ssr: false,
    variables: {
      itemId
    },
  });

  useEffect(() => {
    if (storeId && storeId !== '8119') {
      makeItemRequest();
    }
  }, [storeId]);

  const sampleId = productData?.product?.identifiers?.sampleId;
  const isSuperSku = productData?.product?.identifiers?.isSuperSku;
  const parentId = productData?.product?.identifiers?.parentId;

  const [makeSampleReq, sample] = useLazyDataModel('sampleProduct', {
    ssr: false,
    variables: {
      itemId: sampleId,
      storeId,
      zipCode
    },
  });

  useEffect(() => {
    if (sampleId && zipCode && storeId !== '8119') {
      makeSampleReq({ variables: { storeId, zipCode } });
    }
  }, [sampleId, zipCode, storeId]);

  let dimensionText = '';
  let price;

  const product = sample?.data?.product;

  if (product?.specificationGroup) {
    const getDimensionText = (dimension) => {
      return `${(dimension.specValue.match(/\d+/g) || [])[0]} ${dimension.specName.split('(')[1].split(')')[0]}`;
    };

    const { specifications: dimensions } = product.specificationGroup
      .find((spec) => spec.specTitle === 'Dimensions') || {};

    const length = (dimensions || []).find(({ specName }) => lengthRE.test(specName) || heightRE.test(specName));
    const lengthText = length ? getDimensionText(length) : '';
    const width = (dimensions || []).find(({ specName }) => widthRE.test(specName));
    const widthText = width ? getDimensionText(width) : '';

    if (length && width) {
      dimensionText = `${lengthText} x ${widthText}`;
    }

    if (product?.pricing) {
      price = product.pricing.value;
    }
  }
  const hasSample = !!sampleId;

  return {
    data: {
      dimensionText, hasSample, isSuperSku, parentId, price, product, sampleId
    },
    loading: loading || sample?.loading
  };
};
